import { AxiosError } from 'axios';

import { notifications } from '@mantine/notifications';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { track } from '@/modules/Analytics';
import { Project } from '@/types/types';

export type ProjectError = {
  start_date?: string[];
  end_date?: string[];
};

const useCreateProject = () => {
  const { axiosInstance } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (newProject: Partial<Project>) => {
      const { data } = await axiosInstance.post<Project>('/api/v1/projects', newProject);
      return data;
    },
    onSuccess: () => {
      track('project_created');
      queryClient.invalidateQueries({ queryKey: queryKeys.projects._def });
      notifications.show({
        title: 'Succes',
        message: 'Projekt blev oprettet',
        color: 'green',
      });
    },
    onError(data: AxiosError<ProjectError>) {
      notifications.show({
        title: 'Fejl',
        message: 'Kunne ikke oprette projekt',
        color: 'red',
      });
      return data.response?.data;
    },
  });
};

export default useCreateProject;
